



























import {
  ComponentInternalInstance,
  computed,
  defineComponent,
  getCurrentInstance,
  ref,
  watch,
} from '@vue/composition-api';
import tips from '@/renderer/scripts/utils/tips';
import { httpUrl } from '@/renderer/scripts/http';
import i18n, { i18n_t } from '@/locales/i18n';
import { getSpaceAndUserInfo } from '@/renderer/scripts/utils/user/getUserSpaceInfo';

export default defineComponent({
  name: 'PreviewStencilFile',
  props: {
    show: {
      required: true,
      type: Boolean,
      default: false,
    },
    // 模板Id
    stencilId: {
      required: true,
      type: Number,
    },
  },
  setup(props, context) {
    const currComponent: ComponentInternalInstance = getCurrentInstance() as ComponentInternalInstance;
    const vm = currComponent.proxy;
    const innerShow = computed({
      get: () => props.show,
      set: val => {
        context.emit('update:show', val);
      },
    });
    const loadStencil = ref(false);
    const previewStencilUrl = ref('');

    const methods = {
      onLoadStencileError() {
        loadStencil.value = false;
        tips.error(i18n_t('文件加载出错，请检查是否存在该文件'), 5000);
      },
      onLoadStencilSuccess(e: Event) {
        loadStencil.value = false;
      },
      async onLoadPreviewUrl() {
        loadStencil.value = true;
        const { libraryId, accessToken } = await getSpaceAndUserInfo({
          spaceId: vm.$route.query.spaceId as string,
          spaceOrgId: Number(vm.$route.query?.spaceOrgId) || vm.$store.getters.orgId,
        });
        const url = `${httpUrl.SMHUrl}/api/v1/file-template/${libraryId}/template/${props.stencilId}?preview&access_token=${accessToken}`;
        previewStencilUrl.value = url;
      },
    };
    watch(
      () => innerShow.value,
      val => {
        if (val) {
          methods.onLoadPreviewUrl();
        } else {
          previewStencilUrl.value = '';
        }
      },
    );

    return {
      innerShow,
      loadStencil,
      previewStencilUrl,

      ...methods,
    };
  },
});
